import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricPeriod from './metric-period-model'
import {
  CreateMetricPeriodAsync,
  DeleteMetricPeriodAsync,
  LoadMetricPeriodsAsync,
} from './metricPeriod-thunk'
const initialState: metricPeriodSliceState = {
  metricPeriod: [],
  selected_metricPeriod: '',
  is_loading_metricPeriod: false,
  is_creating_metricPeriod: false,
  is_deleting_metricPeriod: false,
}
export interface metricPeriodSliceState {
  metricPeriod: MetricPeriod[]
  selected_metricPeriod?: string
  is_loading_metricPeriod: boolean
  is_creating_metricPeriod: boolean
  is_deleting_metricPeriod: boolean
}
export const metricPeriodSlice = createSlice({
  name: 'metricPeriod',
  initialState,
  reducers: {
    setSelectedmetricPeriod: (state, action) => {
      state.selected_metricPeriod = action.payload
    },
    clearStatemetricPeriod: (state) => {
      state.metricPeriod = []
      state.is_loading_metricPeriod = false
      state.is_creating_metricPeriod = false
      state.is_deleting_metricPeriod = false
    },
    mergemetricPeriod: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricPeriod = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricPeriod = merge(state.metricPeriod, payload) as any
        }
      }
    },

    add_metricPeriod: (state, action) => {
      if (action.payload) {
        state.metricPeriod = [...state.metricPeriod, action.payload]
      }
    },
    set_metricPeriod: (state, action) => {
      let { key, value, id } = action.payload
      state.metricPeriod = state.metricPeriod.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricPeriodsAsync.pending, (state) => {
      state.is_loading_metricPeriod = true
    })
    builder.addCase(LoadMetricPeriodsAsync.fulfilled, (state, action) => {
      state.is_loading_metricPeriod = false
      if (action.payload) {
        state.metricPeriod = action.payload
      }
    })
    builder.addCase(LoadMetricPeriodsAsync.rejected, (state) => {
      state.is_loading_metricPeriod = false
    })
    builder.addCase(CreateMetricPeriodAsync.pending, (state) => {
      state.is_creating_metricPeriod = true
    })
    builder.addCase(CreateMetricPeriodAsync.fulfilled, (state) => {
      state.is_creating_metricPeriod = false
    })
    builder.addCase(CreateMetricPeriodAsync.rejected, (state) => {
      state.is_creating_metricPeriod = false
    })
    builder.addCase(DeleteMetricPeriodAsync.pending, (state) => {
      state.is_deleting_metricPeriod = true
    })
    builder.addCase(DeleteMetricPeriodAsync.fulfilled, (state, action) => {
      state.is_deleting_metricPeriod = false
      if (state.metricPeriod) {
        state.metricPeriod = state.metricPeriod.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMetricPeriodAsync.rejected, (state) => {
      state.is_deleting_metricPeriod = false
    })

    builder.addCase(
      autoThunks.get_metric_deplyoment_periods.pending,
      (state) => {
        state.is_loading_metricPeriod = true
      },
    )
    builder.addCase(
      autoThunks.get_metric_deplyoment_periods.fulfilled,
      (state, action) => {
        state.is_loading_metricPeriod = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_metric_deplyoment_periods.rejected,
      (state) => {
        state.is_loading_metricPeriod = false
      },
    )

    builder.addCase(autoThunks.get_all_metric_periods.pending, (state) => {
      state.is_loading_metricPeriod = true
    })
    builder.addCase(
      autoThunks.get_all_metric_periods.fulfilled,
      (state, action) => {
        state.is_loading_metricPeriod = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_metric_periods.rejected, (state) => {
      state.is_loading_metricPeriod = false
    })
  },
})

function handleResult(action: any, state: metricPeriodSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricPeriod = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricPeriod = merge(state.metricPeriod, payload) as any
    }
  }
}

export const {
  clearStatemetricPeriod,
  setSelectedmetricPeriod,
  set_metricPeriod,
  mergemetricPeriod,
  add_metricPeriod,
} = metricPeriodSlice.actions

export const get_metricPeriod =
  (id?: string) =>
  (state: {
    metricPeriod: {
      metricPeriod: MetricPeriod[]
    }
  }): MetricPeriod | null => {
    let temp = state?.metricPeriod?.metricPeriod?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.metricPeriod?.metricPeriod[0] || null
  }
export const get_selected_metricPeriod = (state: {
  metricPeriod: metricPeriodSliceState
}): MetricPeriod | null => {
  let id = state?.metricPeriod?.selected_metricPeriod
  let temp = state?.metricPeriod?.metricPeriod?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricPeriod = (state: {
  metricPeriod: {
    metricPeriod: MetricPeriod[]
  }
}): MetricPeriod[] => {
  let temp = state?.metricPeriod?.metricPeriod
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricPeriod_busy = (state: {
  metricPeriod: metricPeriodSliceState
}) => {
  return (
    state?.metricPeriod.is_deleting_metricPeriod ||
    state?.metricPeriod.is_loading_metricPeriod ||
    state?.metricPeriod.is_creating_metricPeriod
  )
}
export const is_deleting_metricPeriod_busy = (state: {
  metricPeriod: metricPeriodSliceState
}) => {
  return state?.metricPeriod.is_deleting_metricPeriod
}
export const is_loading_metricPeriod_busy = (state: {
  metricPeriod: metricPeriodSliceState
}) => {
  return state?.metricPeriod.is_loading_metricPeriod
}
export const is_creating_metricPeriod_busy = (state: {
  metricPeriod: metricPeriodSliceState
}) => {
  return state?.metricPeriod.is_creating_metricPeriod
}

export default metricPeriodSlice.reducer
